export function buildCategoryEventName(primaryCategory, eventName) {
  return {
    category: { primaryCategory },
    eventInfo: { eventName },
  };
}